import React, { useCallback, useEffect, useMemo, useState } from 'react';
// import { useSignals } from '@preact/signals-react/runtime';
import { uniq } from 'underscore';
import jsonData from '../../signals/jsonData';
import appState from '../../signals/appState';
import configData from '../../signals/configData';
import setLanguage from '../../hooks/setLanguage';
import translation from '../../signals/translations';
import splitMultiValue from '../../tools/splitMultiValue';
import IconMap from '../../icons/IconMap';
import IconReport from '../../icons/IconReport';
import IconList from '../../icons/IconList';
import IconHeart from '../../icons/IconHeart';
import IconSearch from '../../icons/IconSearch';
import IconPrint from '../../icons/IconPrint';
import IconArrowDown from '../../icons/IconArrowDown';
import IconMarker from '../../icons/IconMarker';
import IconEndNav from '../../icons/IconEndNav';
import IconRoute from '../../icons/IconRoute';
import IconMarkerFav from '../../icons/IconMarkerFav';
import IconMarkerSearch from '../../icons/IconMarkerSearch';
import SlideToggle from '../SlideToggle';

const LeftPanel = () => {
	// useSignals();

	const { MobileMenu, activeFloor, exhibitorSection, currentNavStart } = appState.value;
	const { languages, basicInfo, exhibitorInfo, navigationInfo, floorInfo, currentLanguage } = jsonData.value;
	const { introduction, openRecommendedRoutes: showRecommendedRoutes } = configData.value;

	const [languagesOpen, setLanguagesOpen] = useState(false);

	const toggleLanguages = () => {
		setLanguagesOpen(!languagesOpen);
	};

	const toggleUI = (ui) => {
		appState.value = {
			...appState.value,
			[ui]: !appState.value[ui],
		};
	};

	const openMyFavorites = () => {
		appState.value = {
			...appState.value,
			MyFavourites: true,
			ExhibitorList: false,
			SearchPanel: false,
		};
	};

	const openRecommendedRoutes = () => {
		appState.value = {
			...appState.value,
			RecommendedRoutes: true,
			ExhibitorList: false,
			MyFavourites: false,
			SearchPanel: false,
		};
	};

	const openSearchPanel = () => {
		appState.value = {
			...appState.value,
			SearchPanel: true,
			MyFavourites: false,
			ExhibitorList: false,
		};
	};

	const openExhibitorList = (section) => {
		appState.value = {
			...appState.value,
			ExhibitorList: true,
			MyFavourites: false,
			SearchPanel: false,
			exhibitorSection: section,
		};
	};

	const closeAllUI = () => {
		const firstFloorIndex = floorInfo.findIndex((f) => String(f?.floor) === '1');
		appState.value = {
			...appState.value,
			ExhibitionInfo: false,
			ExhibitorList: false,
			MyFavourites: false,
			ExhibitorInfo: false,
			SearchPanel: false,
			RecommendedRoutes: false,
			MobileMenu: false,
			activeRoute: null,
			navigation: false,
			selectedBooth: null,
			selectedExhibitor: null,
			activeFloor: firstFloorIndex >= 0 ? firstFloorIndex : 0,
		};
	};

	const openExhibitorSection = (section) => {
		appState.value = { ...appState.value, ExhibitorList: true, exhibitorSection: section };
	};

	const currentUrl = window.location.href ? window.location.href.split('?')[0] : '';

	const exhibitorSections = useMemo(() => {
		const key = '區域';
		// 分類欄位填多個的時候，選單要列的是拆開之後的每一個分類，
		// 不是「A;B」那一整串 —— 那一串點下去在 ExhibitorList 裡對不到任何分組。
		const allSections = exhibitorInfo.reduce((acc, exhibitor) => {
			return acc.concat(splitMultiValue(exhibitor[key]));
		}, []);
		return uniq(allSections);
	}, [exhibitorInfo]);

	const stopNavigation = () => {
		appState.value = {
			...appState.value,
			navigation: false,
		};
	};

	const setCurrentNavStart = useCallback((nav) => {
		appState.value = {
			...appState.value,
			currentNavStart: nav,
		};
	}, []);

	const currentFloor = useMemo(() => {
		return floorInfo[activeFloor];
	}, [activeFloor, floorInfo]);

	const currentFloorNavigationInfo = useMemo(() => {
		return navigationInfo.filter((nav) => nav['樓層數'] === currentFloor?.floor.toString());
	}, [currentFloor, navigationInfo]);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const startParam = urlParams.get('start');
		const floorParam = urlParams.get('floor');

		if (startParam && floorParam && Number(floorParam) === activeFloor) {
			const [lat, lng] = startParam.split(',');
			const navFromUrl = {
				名稱: 'URL Start',
				X軸: lat,
				Y軸: lng,
				樓層數: activeFloor.toString(),
				序號: 'url_start',
			};
			setCurrentNavStart(navFromUrl);
		} else {
			const defaultNavStart = currentFloorNavigationInfo.filter((nav) => nav['預設'] === '1')[0] || currentFloorNavigationInfo[0];
			if (defaultNavStart) setCurrentNavStart(defaultNavStart);
		}
	}, [activeFloor, currentFloorNavigationInfo, setCurrentNavStart]);

	return (
		<div id='LeftPanel'>
			<div className='mobile-menu'>
				<div className='exhibition-name'>{basicInfo.name}</div>

				<div className='controls'>
					<div className='language-chooser' onClick={toggleLanguages}>
						<div className='icon-wrap'>
							<div className='material-symbols-rounded font-icon'>language</div>
						</div>

						<div className={`languages ${languagesOpen ? 'active' : ''}`}>
							{languages.map((language) => {
								const { code, nameNative } = language;
								const isCurrent = code === jsonData.value.currentLanguage.code;

								return (
									<div className='language-wrap' key={code}>
										<div
											className={`language ${isCurrent ? 'active' : ''}`}
											onClick={() => {
												setLanguage(code);
												setLanguagesOpen(false);
											}}>
											{nameNative}
										</div>
									</div>
								);
							})}
						</div>
					</div>

					<div
						className='menu-toggler'
						onClick={() => {
							toggleUI('MobileMenu');
						}}></div>
				</div>
			</div>

			<div className={`mobile-drawer ${MobileMenu ? 'active' : ''}`}>
				<div className='control-item' onClick={closeAllUI}>
					<IconMap />
					<div className='text'>{translation('leftPanel.map')}</div>
				</div>

				{introduction ? (
					<div
						className='control-item'
						onClick={() => {
							toggleUI('ExhibitionInfo');
						}}>
						<IconReport />
						<div className='text'>{translation('leftPanel.exhibitionInfo')}</div>
					</div>
				) : null}

				{showRecommendedRoutes ? (
					<div className='control-item' onClick={openRecommendedRoutes}>
						<IconRoute />
						<div className='text'>{translation('leftPanel.recommendedRoutes')}</div>
					</div>
				) : null}

				<SlideToggle collapsed>
					{({ toggle, setCollapsibleElement }) => (
						<div>
							<div className='control-item' onClick={toggle}>
								<IconList />
								<div className='text'>{translation('leftPanel.exhibitorList')}</div>
								<IconArrowDown />
							</div>

							<div className='collapsible' ref={setCollapsibleElement}>
								<div
									className={`control-item sub ${exhibitorSection === 'all' ? 'active' : ''}`}
									onClick={() => {
										openExhibitorList('all');
									}}>
									<div className='text'>{translation('leftPanel.exhibitorList.all')}</div>
								</div>
								{exhibitorSections.map((section, index) => {
									return (
										<div
											className={`control-item sub ${exhibitorSection === section ? 'active' : ''}`}
											key={section + index}
											onClick={() => {
												openExhibitorList(section);
											}}>
											<div className='text'>{section}</div>
										</div>
									);
								})}
							</div>
						</div>
					)}
				</SlideToggle>

				<div className='control-item' onClick={openMyFavorites}>
					<IconHeart />
					<div className='text'>{translation('leftPanel.myFavorite')}</div>
				</div>

				<SlideToggle collapsed>
					{({ toggle, setCollapsibleElement }) => (
						<div>
							<div className='control-item' onClick={toggle}>
								<IconMarker />
								<div className='text'>{translation('leftPanel.navigationPoints')}</div>
								<IconArrowDown />
							</div>

							<div className='collapsible' ref={setCollapsibleElement}>
								{currentFloorNavigationInfo.map((nav, index) => {
									return (
										<div
											className={`control-item sub ${currentNavStart?.['序號'] === nav['序號'] ? 'active' : ''}`}
											key={nav['序號'] + index}
											onClick={() => {
												setCurrentNavStart(nav);
												toggleUI('MobileMenu');
											}}>
											<div className='text'>{nav['名稱']}</div>
										</div>
									);
								})}
							</div>
						</div>
					)}
				</SlideToggle>

				<div className='control-item' onClick={stopNavigation}>
					<IconEndNav />
					<div className='text'>{translation('leftPanel.endNavigation')}</div>
				</div>

				<div className='control-item' onClick={openSearchPanel}>
					<IconSearch />
					<div className='text'>{translation('leftPanel.advancedSearch')}</div>
				</div>

				<SlideToggle collapsed>
					{({ toggle, setCollapsibleElement }) => (
						<div>
							<div className='control-item' onClick={toggle}>
								<IconPrint />
								<div className='text'>{translation('leftPanel.downloadPrint')}</div>
								<IconArrowDown />
							</div>

							<div className='collapsible' ref={setCollapsibleElement}>
								<a className='control-item sub' href={`${currentUrl}?page=single-floor&floor=${activeFloor}&lang=${currentLanguage.code}&orientation=portrait`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>
										{translation('leftPanel.downloadPrint.singleFloor')} ({translation('leftPanel.downloadPrint.portrait')})
									</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=single-floor&floor=${activeFloor}&lang=${currentLanguage.code}&orientation=landscape`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>
										{translation('leftPanel.downloadPrint.singleFloor')} ({translation('leftPanel.downloadPrint.landscape')})
									</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=multi-floor&lang=${currentLanguage.code}&orientation=portrait`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>
										{translation('leftPanel.downloadPrint.allMaps')} ({translation('leftPanel.downloadPrint.portrait')})
									</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=multi-floor&lang=${currentLanguage.code}&orientation=landscape`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>
										{translation('leftPanel.downloadPrint.allMaps')} ({translation('leftPanel.downloadPrint.landscape')})
									</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=exhibitor-list&lang=${currentLanguage.code}&orientation=portrait`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>
										{translation('leftPanel.downloadPrint.exhibitorList')} ({translation('leftPanel.downloadPrint.portrait')})
									</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=exhibitor-list&lang=${currentLanguage.code}&orientation=landscape`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>
										{translation('leftPanel.downloadPrint.exhibitorList')} ({translation('leftPanel.downloadPrint.landscape')})
									</div>
								</a>
							</div>
						</div>
					)}
				</SlideToggle>

				<div className='desktop-legends'>
					<div className='legends-heading'>{translation('rightPanel.keys')}</div>
					<div className='legends'>
						<div className='legend-row' onClick={() => toggleUI('MyFavourites')}>
							<div className='legend'><IconMarkerFav /></div>
							<div className='legend-text'>{translation('rightPanel.keys.myFavorite')}</div>
						</div>
						<div className='legend-row' onClick={() => toggleUI('SearchPanel')}>
							<div className='legend'><IconMarkerSearch /></div>
							<div className='legend-text'>{translation('rightPanel.keys.searchResult')}</div>
						</div>
						{currentFloor && Array.isArray(currentFloor.sections) && currentFloor.sections.length > 0 ? (
							currentFloor.sections.map((section, index) => (
								<div className='legend-row' key={`ld-legend-${index}`} onClick={() => openExhibitorSection(section.name)}>
									<div className='legend'><div className='color' style={{ backgroundColor: section.fillColor }}></div></div>
									<div className='legend-text'>{section.name}</div>
								</div>
							))
						) : (
							<div className='legend-row'>無區域資料</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default LeftPanel;
